import Relay from 'react-relay';


/**
*  Update circle mutation
*/
export default class UpdateCircleMutation extends Relay.Mutation {
  /**
  *  Mutation
  */
  getMutation() {
    return Relay.QL`mutation{
      updateCircle
    }`;
  }
  /**
  *  Variables
  */
  getVariables() {
    let circleId;
    if(this.props.circleId)
        circleId = this.props.circleId
    else if(this.props.circle.id){
        circleId = this.props.circle.id
    }
    return {
      circleId: circleId,
      circle: this.props.circle
    };
  }
  /**
  *  Fat query
  */
  getFatQuery() {
    return Relay.QL`
      fragment on updateCirclePayload @relay(pattern: true){
        viewer {
          circles
        }
        edge{
          node
        }
      }
    `;
  }

  /**
  *  Config
  */
  getConfigs() {
    return [{
      type: 'FIELDS_CHANGE',
      fieldIDs: {
        viewer: this.props.viewer.id,
        edge :{
          node : this.props.circle.id,
        }
      },
    }];
  }

  static fragments = {
    viewer: () => Relay.QL`
      fragment on Viewer {
        id
      }
    `,
  }
}



// WEBPACK FOOTER //
// ./src/mutations/Circle/UpdateCircleMutation.js